import type { FeedbackCheckboxField } from 'react-common'
import { useTranslation } from 'react-i18next'

export const useFeedbackOptions = (): FeedbackCheckboxField[] => {
  const { t } = useTranslation()

  return [
    {
      name: 'no',
      label: t('Feedback.options.no'),
    },
    {
      name: 'navigation',
      label: t('Feedback.options.navigation'),
    },
    {
      name: 'startFinishCourse',
      label: t('Feedback.options.startFinishCourse'),
    },
    {
      name: 'activityResults',
      label: t('Feedback.options.activityResults'),
    },
    {
      name: 'communicationHub',
      label: t('Feedback.options.communicationHub'),
    },
    {
      name: 'courseActivities',
      label: t('Feedback.options.courseActivities'),
    },
    {
      name: 'examConnection',
      label: t('Feedback.options.examConnection'),
    },
    {
      name: 'accessibility',
      label: t('Feedback.options.accessibility'),
    },
    {
      name: 'registration',
      label: t('Feedback.options.registration'),
    },
    {
      name: 'contentManagement',
      label: t('Feedback.options.contentManagement'),
    },
    {
      name: 'reports',
      label: t('Feedback.options.reports'),
    },
    {
      name: 'adminFunctionality',
      label: t('Feedback.options.adminFunctionality'),
    },
    {
      name: 'other',
      label: t('Feedback.options.other'),
    },
  ]
}
